import React from "react";
import styles from "./Status-badge.module.css";

interface StatusBadgeProps {
  children: React.ReactNode;
  type?: string
  scale?: number;
  fontSize?: string;
  circleSize?: string;
}

function StatusBadge({
  children,
  type,
  scale = 1,
  fontSize = "16px",
  circleSize = "8px",
}: StatusBadgeProps) {
  // Маппинг классов и цветов для каждого типа статуса
  const statusConfig: Record<string, { badgeClass: string; circleClass: string; circleColor: string }> = {
    active: {
      badgeClass: `${styles.badge} ${styles["badge-active"]}`,
      circleClass: `${styles.circle} ${styles["circle-active"]}`,
      circleColor: "#30bb67",
    },
    test: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    error: {
      badgeClass: `${styles.badge} ${styles["badge-error"]}`,
      circleClass: `${styles.circle} ${styles["circle-error"]}`,
      circleColor: "#d83a3a",
    },
    processing: {
      badgeClass: `${styles.badge} ${styles["badge-processing"]}`,
      circleClass: `${styles.circle} ${styles["circle-processing"]}`,
      circleColor: "#3498db",
    },
    unsaved: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    DRAFT: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    ERROR: {
      badgeClass: `${styles.badge} ${styles["badge-error"]}`,
      circleClass: `${styles.circle} ${styles["circle-error"]}`,
      circleColor: "#d83a3a",
    },
    IN_PROCESSING: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    PROCESSED: {
      badgeClass: `${styles.badge} ${styles["badge-active"]}`,
      circleClass: `${styles.circle} ${styles["circle-active"]}`,
      circleColor: "#30bb67",
    },
    IN_ACCEPTANCE: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    IN_CONFIRMATION: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    WAITING_FOR_DELIVERY: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    WITHDRAWN: {
      badgeClass: `${styles.badge} ${styles["badge-error"]}`,
      circleClass: `${styles.circle} ${styles["circle-error"]}`,
      circleColor: "#d83a3a",
    },
    REJECTED: {
      badgeClass: `${styles.badge} ${styles["badge-error"]}`,
      circleClass: `${styles.circle} ${styles["circle-error"]}`,
      circleColor: "#d83a3a",
    },
    SIGNED_BY_RECIPIENT: {
      badgeClass: `${styles.badge} ${styles["badge-active"]}`,
      circleClass: `${styles.circle} ${styles["circle-active"]}`,
      circleColor: "#30bb67",
    },
    NOT_PROCESSED: {
      badgeClass: `${styles.badge} ${styles["badge-error"]}`,
      circleClass: `${styles.circle} ${styles["circle-error"]}`,
      circleColor: "#d83a3a",
    },
    default: {
      badgeClass: styles.badge,
      circleClass: styles.circle,
      circleColor: "#678aa1",
    },
  };

  const { badgeClass, circleClass, circleColor } = statusConfig[type || "default"];

  const circleStyle = {
    width: circleSize,
    height: circleSize,
    backgroundColor: circleColor,
  };

  const style = {
    transform: `scale(${scale})`,
    fontSize, // Размер шрифта из props
  };

  return (
    <div className={badgeClass} style={style}>
      <div className={circleClass} style={circleStyle}></div>
      {children}
    </div>
  );
}

export default StatusBadge;
